import { useCallback, useMemo } from 'react';
import { useTranslations } from 'next-intl';
import { useParams } from 'next/navigation';
import { useEvent, useUnit } from 'effector-react';
import { IconsMap } from '@nx-frontend/shared/ui/icon';
import { useCreateNote } from '@nx-frontend/shared/hooks/use-create/use-note-create';
import { $currentWorkspace } from '@nx-frontend/shared/store/current-workspace';
import { addTagToNoteEvent } from '@nx-frontend/shared/store/tags';

export const useGetTagsAllDocsButtons = () => {
  const params = useParams();
  const slug = useMemo(() => params?.slug || [], [params?.slug]) as string[];

  const [currentWorkspace] = useUnit([$currentWorkspace]);
  const [addTagToNote] = useEvent([addTagToNoteEvent]);
  const createNote = useCreateNote();

  const t = useTranslations('webnotes');

  return useCallback(() => {
    const [, , encodedCurrentTag] = slug || [];
    const currentTag = decodeURIComponent(encodedCurrentTag);
    return [
      {
        icon: IconsMap.DOCUMENT,
        title: t('webnotes-new_page'),
        subTitle: t('webnotes-new_page_description'),
        id: 'newPageWithTag',
        action: async () => {
          const createdNote = await createNote({
            workspaceId: currentWorkspace.globalId,
            parentId: 'default',
            redirectAfterCreate: true,
          });
          if (createdNote) {
            addTagToNote({ noteId: createdNote.globalId, tag: currentTag });
          }
        },
      },
      {
        icon: IconsMap.TEMPLATE,
        title: t('webnotes-templates'),
        subTitle: t('webnotes-templates_description'),
        id: 'template',
      },
    ];
  }, [t, addTagToNote, createNote, currentWorkspace.globalId, slug]);
};
